import React from 'react';
import { TIPI_PARTITA, FASCE_PARTITA } from './utils/matchUtils';

const MatchConfigurationPanel = ({
  squadreDisponibili,
  squadra1,
  squadra2,
  tipoPartita,
  fasciaPartita,
  isReadonly,
  isEditMode,
  partitaCorrente,
  isConfigComplete,
  onSquadra1Change,
  onSquadra2Change,
  onTipoChange,
  onFasciaChange,
  onSave,
  onReset,
  isSaving,
  saveDisabled = false,
  saveDisabledReason
}) => {
  return (
    <div className="match-configurazione-panel">
      <div className="match-configurazione-header">
        <h2>
          {isEditMode ? 'Modifica Partita' : 'Nuova Partita'}
        </h2>
      </div>
      
      <div className="match-configurazione-content">
        {/* Selezione Squadre */}
        <div className="match-squadre-selection-inline">
          <div className="match-form-group compact">
            <label htmlFor="squadra1">
              <i className="fas fa-users"></i>
              Squadra 1:
            </label>
            <select 
              id="squadra1" 
              value={squadra1?.id || ''} 
              onChange={onSquadra1Change}
              disabled={isReadonly}
            >
              <option value="">Seleziona squadra 1</option>
              {squadreDisponibili
                .sort((a, b) => a.nome.localeCompare(b.nome))
                .map(squadra => (
                  <option 
                    key={squadra.id} 
                    value={squadra.id} 
                    disabled={squadra2?.id === squadra.id}
                  >
                    {squadra.nome}
                  </option>
                ))}
            </select>
          </div>

          <div className="match-form-group compact">
            <label htmlFor="squadra2">
              <i className="fas fa-users"></i>
              Squadra 2:
            </label>
            <select 
              id="squadra2" 
              value={squadra2?.id || ''} 
              onChange={onSquadra2Change}
              disabled={!squadra1 || isReadonly}
            >
              <option value="">Seleziona squadra 2</option>
              {squadreDisponibili
                .filter(squadra => squadra.id !== squadra1?.id)
                .sort((a, b) => a.nome.localeCompare(b.nome))
                .map(squadra => (
                  <option key={squadra.id} value={squadra.id}>
                    {squadra.nome}
                  </option>
                ))}
            </select>
          </div>
        </div>

        {/* Tipo e Fascia */}
        <div className="match-tipo-fascia-inline">
          <div className="match-form-group compact">
            <label htmlFor="tipo">
              <i className="fas fa-trophy"></i>
              Tipo:
            </label>
            <select 
              id="tipo" 
              value={tipoPartita} 
              onChange={(e) => onTipoChange(e.target.value)}
              disabled={!squadra2 || isReadonly}
            >
              <option value="">Seleziona tipo</option>
              {TIPI_PARTITA.map(tipo => (
                <option key={tipo} value={tipo}>
                  {tipo.charAt(0).toUpperCase() + tipo.slice(1)}
                </option>
              ))}
            </select>
          </div>

          <div className="match-form-group compact">
            <label htmlFor="fascia">
              <i className="fas fa-layer-group"></i>
              Fascia:
            </label>
            <select 
              id="fascia" 
              value={fasciaPartita} 
              onChange={(e) => onFasciaChange(e.target.value)}
              disabled={!tipoPartita || isReadonly}
            >
              <option value="">Seleziona fascia</option>
              {FASCE_PARTITA.map(fascia => (
                <option key={fascia} value={fascia}>
                  fascia {fascia.charAt(0).toUpperCase() + fascia.slice(1)}
                </option>
              ))}
            </select>
          </div>
        </div>
        
        <div className="match-buttons-container">
          <button
            className="match-btn-salva"
            onClick={onSave}
            disabled={!isConfigComplete || isSaving || saveDisabled}
            title={saveDisabled ? saveDisabledReason : undefined}
          >
            <i className={`fas ${isSaving ? 'fa-spinner fa-spin' : (isEditMode ? 'fa-edit' : 'fa-save')}`}></i>
            {isSaving ? 'Salvataggio...' : (isEditMode ? 'Aggiorna Partita' : 'Salva Partita')}
          </button>
          
          <button 
            className="match-btn-referto"
            onClick={() => console.log('Referto clicked')}
            disabled={!isConfigComplete}
          >
            <i className="fas fa-file-alt"></i>
            Referto
          </button>
        </div>
      </div>
    </div>
  );
};

export default MatchConfigurationPanel;